export function uploadChangeDirective() {
  "njInject";
  return {
    scope: {
      uiUploadChange: "&" },

    link: function link($scope, $element, $attrs) {
      $element.on("change", function (event) {
        $scope.$apply(function () {
          $scope.uiUploadChange({ $event: event });
        });
      });
      $scope.$on("$destroy", function () {
        $element.off();
      });
    } };

}